exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".experience-accord {\n  margin: 50px;\n}\n\n.accord-panel {\n  font-family: \"Google Sans Regular\";\n}\n\n@media (max-width: 768px) {\n  .experience-accord {\n    margin: 20px;\n  }\n}\n", ""]);

